import { Link } from "react-router-dom";

/**
 * Render a stock-log note where `DB-YYYY-NNNNNN` order refs become clickable
 * links to the admin order detail page.
 *
 * We keep this as a lookup component so `StockLogs.jsx` can pass the whole
 * order list and we resolve DB-numbers to IDs without an extra API call.
 */
export default function StockLogNote({ note, ordersByNumber }) {
  if (!note) return null;
  const parts = String(note).split(/(DB-\d{4}-\d{6})/g);
  return (
    <span>
      {parts.map((chunk, i) => {
        if (/^DB-\d{4}-\d{6}$/.test(chunk)) {
          const o = ordersByNumber?.[chunk];
          if (o) {
            return (
              <Link
                key={i}
                to={`/admin/orders/${o.id}`}
                className="db-mono text-[#2D6A4F] hover:underline"
                data-testid={`stock-log-order-link-${chunk}`}
              >
                {chunk}
              </Link>
            );
          }
          return <span key={i} className="db-mono">{chunk}</span>;
        }
        return <span key={i}>{chunk}</span>;
      })}
    </span>
  );
}
